import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { DoctorDto, DoctorSearchRequest, UpsertDoctorDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/doctors`;

export const getAllDoctors = (source: CancelTokenSource): Promise<Array<DoctorDto>> => {
  return axios
      .get(apiUri, {cancelToken: source.token})
      .then((response) => response.data);
};

export const searchDoctors = (doctorSearchRequest: Partial<DoctorSearchRequest>,
                              source: CancelTokenSource): Promise<Array<DoctorDto>> => {
  return axios
      .post(`${apiUri}/search`, doctorSearchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const searchDoctorsForInput = (
    query: string,
    source: CancelTokenSource, limit?: number)
    : Promise<Array<DoctorDto>> => {

  const queryParams = {
    query: query,
    limit: limit
  };

  return axios
      .get(apiUri, {cancelToken: source.token, params: queryParams})
      .then(response => response.data)
};

export const findDoctorById = (id: number, source: CancelTokenSource): Promise<UpsertDoctorDto> => {
  return axios
      .get(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data)
};

export const saveDoctor = (upsertDoctorDto: Partial<UpsertDoctorDto>): Promise<DoctorDto> => {
  return axios
      .post(apiUri, upsertDoctorDto)
      .then(response => response.data);
};

export const editDoctor = (id: number, upsertDoctorDto: Partial<UpsertDoctorDto>): Promise<DoctorDto> => {
  return axios
      .put(`${apiUri}/${id}`, upsertDoctorDto)
      .then(response => response.data);
};

export const deleteDoctor = (id: number, source: CancelTokenSource): Promise<DoctorDto> => {
  return axios
      .delete(`${apiUri}/${id}`, {cancelToken: source.token})
      .then(response => response.data);
};
